import { useState, useCallback } from 'react';
import { AdsStudioPageName } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
/* istanbul ignore next */
export const useLoadData = ({
  filters, perfMetricDateRange, onFailedToLoadData, loadMoreDataInDateRange, loadDataInDateRange, perfMarker,
}) => {
  const [loadingData, setLoadingData] = useState(false);
  const [loadingMoreData, setLoadingMoreData] = useState(false);

  const loadNextPage = useCallback((count) => {
    setLoadingMoreData(true);
    return loadMoreDataInDateRange({ count }).catch((err) => {
      onFailedToLoadData(err);
    }).finally(() => setLoadingMoreData(false));
  }, [loadMoreDataInDateRange, onFailedToLoadData]);

  const loadDataAsync = useCallback((count, sortBy) => {
    const { isGlobalSearch, ...otherFilters } = filters;

    return loadDataInDateRange({
      perfMetricDateRange,
      ...otherFilters,
      sortBy,
      assetsToLoadForSubfolders: 0,
      isGlobalSearch,
      includeParentHierarchy: isGlobalSearch, // include parent hierarchy when global searching
      includeSubfolders: false,
      count,
      pageName: AdsStudioPageName.PerfPage,
      perfMarker: perfMarker.createChild('performancePageLoadData'),
    });
  }, [filters, loadDataInDateRange, perfMetricDateRange]);

  return {
    loadingData,
    setLoadingData,
    loadingMoreData,
    loadNextPage,
    loadDataAsync,
  };
};
